<template>
	<div class="c-video-renderer">
		<a class="c-video-renderer__inner" target="_blank" :href="note.ref">
			<div class="c-video-renderer__cover">
				<img v-if="cover" :src="cover" />
			</div>
			<div class="c-video-renderer__scrubber">
				<article
					:class="['c-video-renderer__popup', { 'has-comment': comment }]"
					:style="{ left: position }"
				>
					<article class="c-video-renderer__popup__inner">
						<span>{{ time }}</span
						><span class="divider" v-if="comment">-</span>
						<p v-if="comment">{{ comment }}</p>
					</article>
				</article>
			</div>
			<article class="c-video-renderer__footer" v-if="note">
				<img v-if="avatar" :src="avatar" />
				<span v-if="title">{{ title }}</span>
			</article>
		</a>
	</div>
</template>

<script>
import youtubeHelper from '@/lib/youtube-helper.js';
export default {
	props: ['note'],
	computed: {
		title: function () {
			if (this.note.meta && this.note.meta.title) {
				return this.note.meta.title;
			} else {
				return '';
			}
		},
		logo: function () {
			if (
				this.note.meta &&
				this.note.meta._video &&
				this.note.meta._video.logo
			) {
				return this.note.meta._video.logo;
			} else {
				return null;
			}
		},
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				return this.note.comment.raw;
			} else {
				return false;
			}
		},
		time: function () {
			if (
				this.note.meta &&
				this.note.meta.video &&
				this.note.meta.video.timestamp
			) {
				return (
					this.note.meta.video.timestamp.time.minutes +
					':' +
					this.note.meta.video.timestamp.time.seconds
				);
			} else {
				return 'NA';
			}
		},
		position: function () {
			let time = youtubeHelper.timeToSeconds(
				this.note.meta.video.timestamp.time
			);
			let totalTime = youtubeHelper.timeToSeconds(
				this.note.meta.video.timestamp.totalTime
			);
			if (time > totalTime) {
				return '0%';
			} else {
				let percentage = Math.floor((time / totalTime) * 100);
				return `${percentage}%`;
			}
		},
		avatar: function () {
			if (
				this.note.meta &&
				this.note.meta.resource &&
				this.note.meta.resource.avatar
			) {
				return this.note.meta.resource.avatar;
			}
		},
		cover: function () {
			let str = '';
			if (this.note.meta && this.note.meta.resource) {
				str = `https://img.youtube.com/vi/${this.note.meta.resource.id}/0.jpg`;
			}
			return str;
		},
	},
	methods: {},
};
</script>

<style lang="scss">
.c-video-renderer {
	max-width: 500px;
	overflow: hidden;

	&__inner {
		display: block;
		border-radius: 5px;
		border: var(--g3) solid 1px;
		overflow: hidden;
		cursor: pointer;
		color: var(--body-color);
		background-color: var(--g4);
		transition: color var(--transition-time-sm) linear;
	}

	&__scrubber {
		width: calc(100% - (var(--spacer) * 4));
		margin-left: calc(var(--spacer) * 2);
		position: relative;
		height: 4px;
		background-color: #ff0000;
	}

	&__popup {
		position: absolute;
		//width: 100%;
		max-width: 200px;
		bottom: calc(100% + var(--margin-lg));
		padding: var(--margin-sm) var(--margin-lg);
		font-size: var(--font-size-xs);
		background-color: var(--g2);
		border-radius: var(--border-radius);
		transform: translateX(-50%);

		span {
			opacity: 0.8;
		}

		.divider {
			margin: 0 var(--margin);
			display: inline-block;
		}

		p {
			font-size: var(--font-size-xs);
			margin-bottom: 0;
			display: inline-block;
		}

		&:after {
			content: '';
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);
			border-style: solid;
			border-width: var(--margin) var(--margin) 0 var(--margin);
			border-color: var(--g2) transparent transparent transparent;
		}

		&:before {
			content: '';
			position: absolute;
			top: calc(100% + 8px);
			left: 50%;
			transform: translateX(-50%);
			width: 4px;
			height: 4px;
			background-color: var(--warning-color);
		}

		&.has-comment {
			min-width: calc(var(--spacer) * 2);
		}
	}

	&__cover {
		position: relative;

		height: calc(var(--spacer-lg) * 3);
		background-color: var(--g3);

		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: center center;
			opacity: 0.5;
		}
	}

	&__footer {
		padding: var(--margin) var(--margin-lg);
		font-size: var(--font-size-sm);
		white-space: initial;

		img {
			width: var(--spacer);
			height: var(--spacer);
			margin-right: var(--margin-lg);
			border-radius: 50%;
			object-fit: cover;
		}
	}

	@include media-breakpoint-down(sm) {
		&__text {
			display: none;
		}
	}
}
</style>